import { render } from "./App.vue?vue&type=template&id=6856f514"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6856f514&lang=css"

import exportComponent from "/home/forge/somethingred.j20.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__